export const boldStr = (str = '') => {

    return `<span style='font-weight:bold'>${str}</span>`;
};
export const reveseString = (str) => {
    // var splitString = str.split("");
    // var reverseArray = splitString.reverse(); 
    // var joinArray = reverseArray.join(""); 
    // return joinArray; 
    return `<span style='unicode-bidi: embed;direction: ltr;font-weight:bold'>${str}</span>`;
};

export const EstelamMesage = () => `اطلاعات شما ثبت و برای استعلام ارسال شد. نتیجه استعلام از طریق پیامک اطلاع رسانی خواهد شد.`

export const WarranyStepMessage = {

    'REGISTER_INQUIRY': 'پیام مربوط به تب دوم است  . از فرحزادی گرفته شود.',
    'REJECTED': `درخواست ضمانت‌نامه شما رد شد، از طریق منو ${boldStr('لیست درخواست ها')} از وضعیت درخواست خود مطلع شوید.`,

}


export const checkMessage = (warranty) => {
    const step = warranty?.source['warranty-step'];
    const status = warranty?.source['warranty-status'];

    if (!step) {
        return '';
    }
    if (warranty?.source['warranty-status'] == 'REJECTED') {
        return WarranyStepMessage.REJECTED;
    } else {
        if (step == 'REGISTER_INQUIRY') {
            return `اطلاعات شما ثبت و برای استعلام ارسال شد. نتیجه استعلام از طریق پیامک اطلاع رسانی خواهد شد.`
        } else if (step == 'COLLATERAL_INQUIRY') {
            return `ثبت چک با موفقیت انجام شد، برای مشاهده وضعیت و انجام روند درخواست صدور ضمانت‌نامه به منو ${boldStr('لیست درخواست ها')} مراجعه نمایید.`;
        } else if (step == 'REGISTER_CONTRACT' || step == 'SIGNATURE_CONTRACT' || step == 'FILING' || step == 'REGISTER_WARRANTY' || status == 'ERROR') {
            return `شما دارای درخواست فعال می باشید، از طریق منو ${boldStr('لیست درخواست ها')} از وضعیت درخواست خود مطلع شوید.`;
        } else {
            return 'وجود ندارد.';
        }
    }
}
